export const meetingBodyPositionsCube = {
    category: 'Meeting Bodies',
    description: 'Positions such as Chair or Vice Chair that can be assigned to meeting body members.',
    label: 'Meeting Body Positions',
    measures: {
        'meeting_body_positions.count': { label: 'Count', type: 'number' },
    },
    dimensions: {
        'meeting_body_positions.description': { label: 'Description', narrative: true, type: 'string' },
        'meeting_body_positions.is_archived': { label: 'Is Archived', type: 'boolean' },
        'meeting_body_positions.title': { label: 'Title', type: 'string' },
    },
    timeDimensions: {
        'meeting_body_positions.created_at': { label: 'Created At', type: 'date' },
        'meeting_body_positions.updated_at': { label: 'Updated At', type: 'date' },
    },
};
